 
 <template>
  <section class="block relative z-1">
   
      <div class="px-2 md:px-4 mx-auto w-full">
        <div>
          <!-- Card stats -->
          <div class="flex flex-wrap">
            <div class="w-full lg:w-12/12 xl:w-10/12 px-4">
           
           


            </div>
         
        </div>
      </div>
    </div>

   


                <div
                  class="
                    relative
                    flex flex-col
                    min-w-0
                    break-words
                    w-full
                    mb-6
                    shadow-lg
                    rounded-lg
                    bg-gray-200
                    border-0
                  "
                >
                  <div class="rounded-t bg-white mb-0 px-6 py-6">
                    <div class="text-center flex justify-between">
                      <h6 class="text-dark text-m">Coming Soon</h6>
                    </div>
                  </div>
                  <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
                    <form>
                      <br />
                      <div class="flex flex-wrap">
                        <div class="w-full px-4">
                          <div class="relative w-full mb-3">
                            <div class="text-center mt-8">
                              <br />
                              <i class="fas fa-file-alt text-4xl mb-4 text-red-500"></i>
                              <br />
                              <h4 class="text-red-500 text-xl">
                                You have No BGBB NFTs yet.
                              </h4>
                              <p>
                                This service allows users to see their BGBB NFT collection.
                              </p>
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>






















   
  </section>
</template>


       <script>
// import placeholder from "@/assets/img/placeholder.svg";

export default {
  data() {
    return {
      // placeholder,
      
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  components: {},
};
</script>